var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'react-emotion';
import { Link as BaseLink } from 'docz';
import { get } from '@utils/theme';
export const LinkStyled = styled('a') `
  color: ${get('colors.link')};

  &:visited,
  &:active {
    text-decoration: none;
    color: ${get('colors.link')};
  }

  &:hover {
    color: ${get('colors.link')};
  }

  ${p => p.theme.docz.mq(p.theme.docz.styles.link)};
`;
export const Link = (_a) => {
    var { href } = _a, props = __rest(_a, ["href"]);
    const isInternal = href && href.startsWith('/');
    const Component = isInternal ? LinkStyled.withComponent(BaseLink) : LinkStyled;
    return isInternal ? (React.createElement(Component, Object.assign({}, props, { to: href }))) : (React.createElement(Component, Object.assign({}, props, { href: href })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21wb25lbnRzL3VpL0xpbmsudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFBO0FBRTlCLE9BQU8sTUFBTSxNQUFNLGVBQWUsQ0FBQTtBQUNsQyxPQUFPLEVBQUUsSUFBSSxJQUFJLFFBQVEsRUFBRSxNQUFNLE1BQU0sQ0FBQTtBQUV2QyxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBRWxDLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7V0FDMUIsR0FBRyxDQUFDLGFBQWEsQ0FBQzs7Ozs7YUFLaEIsR0FBRyxDQUFDLGFBQWEsQ0FBQzs7OzthQUlsQixHQUFHLENBQUMsYUFBYSxDQUFDOzs7SUFHM0IsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQztDQUNqRCxDQUFBO0FBSUQsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFtQixDQUFDLEVBQWtCLEVBQUUsRUFBRTtRQUF0QixFQUFFLElBQUksT0FBWSxFQUFWLDRCQUFRO0lBQ25ELE1BQU0sVUFBVSxHQUFHLElBQUksSUFBSSxJQUFJLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQy9DLE1BQU0sU0FBUyxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFBO0lBRTlFLE9BQU8sVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUNsQixvQkFBQyxTQUFTLG9CQUFLLEtBQUssSUFBRSxFQUFFLEVBQUUsSUFBSSxJQUFJLENBQ25DLENBQUMsQ0FBQyxDQUFDLENBQ0Ysb0JBQUMsU0FBUyxvQkFBSyxLQUFLLElBQUUsSUFBSSxFQUFFLElBQUksSUFBSSxDQUNyQyxDQUFBO0FBQ0gsQ0FBQyxDQUFBIn0=